import React from 'react';

import { ReactComponent as AddIcon } from '@assets/svg/add.svg';

import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const ActionItemsButtonAdd = () => {
  const { t } = useTranslation();
  const { setActiveModal } = useModalActions();

  return (
    <Button
      text={t('Add Action Item')}
      id="tourStep-11"
      onClick={() => setActiveModal({ name: 'addActionItemModal' })}
      type="secondary"
      leftElement={<AddIcon className={style.addIcon} />}
      dataQa="add-ai-button"
    />
  );
};

export default ActionItemsButtonAdd;
